const READ = Object.freeze({ classification: Object.freeze({
        sideEffect: "read", egress: "none", approval: "never",
    }) });
const WRITE = Object.freeze({ classification: Object.freeze({
        sideEffect: "write", egress: "none", approval: "never",
    }) });
const INTERNAL_SHARE = Object.freeze({ classification: Object.freeze({
        sideEffect: "write", egress: "internal-share", approval: "policy",
    }) });
const EXTERNAL_SEND = Object.freeze({ classification: Object.freeze({
        sideEffect: "write", egress: "external-send", approval: "policy",
    }) });
export const NATIVE_TOOL_CONTRACTS = Object.freeze({
    analyze_session_history: READ,
    correct_memory: WRITE,
    desk_call: WRITE,
    forget_memory: WRITE,
    load_memory_context: READ,
    load_skill_context: READ,
    load_timeline_range: READ,
    read_workspace_session: READ,
    save_memory: WRITE,
    search_episodic_memory: READ,
    search_session_history: READ,
    search_workspace_resources: READ,
    submit_contract_plan: WRITE,
    twin_add_email_attachments: WRITE,
    twin_apply_channel_widgets: WRITE,
    twin_arrange_channel_widgets: WRITE,
    twin_ask_user: READ,
    twin_candidate_twin_query: READ,
    twin_canvas_guide: READ,
    twin_capture_correction: WRITE,
    twin_create_canvas: WRITE,
    twin_create_channel_widget: WRITE,
    twin_create_csv_artifact: WRITE,
    twin_create_markdown_artifact: WRITE,
    twin_create_markdown_artifact_from_previous_turn: WRITE,
    twin_data_freshness: READ,
    twin_delete_artifact: WRITE,
    twin_entity_context: READ,
    twin_expand_session_contract: WRITE,
    twin_export_warehouse_query_csv: INTERNAL_SHARE,
    twin_fact_check_canvas: READ,
    twin_find_email_attachments: READ,
    twin_finish_answer: READ,
    twin_google_grounded_answer: READ,
    twin_governed_product_query: READ,
    twin_list_channel_widgets: READ,
    twin_plan_and_retrieve_governed_evidence: READ,
    twin_propose_curated_view: WRITE,
    twin_propose_markdown_artifact_revision: WRITE,
    twin_read_artifact: READ,
    twin_read_canvas: READ,
    twin_revise_canvas: WRITE,
    twin_revise_channel_widget: WRITE,
    twin_search_governed_contracts: READ,
    twin_teach_twin: WRITE,
    twin_undo_channel_widget_change: WRITE,
    twin_update_csv_artifact: WRITE,
    twin_update_session_contract: WRITE,
    twin_view_canvas: READ,
    twin_web_search: READ,
    twin_workflow_get: READ,
    twin_workflow_judgment: EXTERNAL_SEND,
    twin_workflow_preview: WRITE,
    twin_workflow_save: WRITE,
    twin_workflow_save_durable: WRITE,
    twin_workflow_schedule: WRITE,
    twin_workflow_schema: READ,
    twin_workspace_aggregate_channel_records: READ,
    twin_workspace_archive_channel: WRITE,
    twin_workspace_create_automation: WRITE,
    twin_workspace_create_channel: WRITE,
    twin_workspace_create_channel_feed_comment: WRITE,
    twin_workspace_create_channel_post: WRITE,
    twin_workspace_create_channel_view: WRITE,
    twin_workspace_create_dashboard_view: WRITE,
    twin_workspace_create_object_field: WRITE,
    twin_workspace_create_object_fields: WRITE,
    twin_workspace_create_object_type: WRITE,
    twin_workspace_create_record: WRITE,
    twin_workspace_create_record_from_source: WRITE,
    twin_workspace_create_records: WRITE,
    twin_workspace_create_source_backed_channel: WRITE,
    twin_workspace_create_twin_product_channel: WRITE,
    twin_workspace_delete_channel_feed_comment: WRITE,
    twin_workspace_delete_channel_file: WRITE,
    twin_workspace_delete_channel_post: WRITE,
    twin_workspace_export_channel_records_csv: INTERNAL_SHARE,
    twin_workspace_extract_file: READ,
    twin_workspace_feed: READ,
    twin_workspace_get_channel_feed_thread: READ,
    twin_workspace_get_notification_capabilities: READ,
    twin_workspace_impact: READ,
    twin_workspace_link_inbox_items_to_channel: WRITE,
    twin_workspace_list_automations: READ,
    twin_workspace_list_channel_feed: READ,
    twin_workspace_list_channel_files: READ,
    twin_workspace_list_channel_members: READ,
    twin_workspace_list_channel_records: READ,
    twin_workspace_list_channel_schema: READ,
    twin_workspace_list_channels: READ,
    twin_workspace_list_notification_preferences: READ,
    twin_workspace_list_notification_watches: READ,
    twin_workspace_open_data_set_view: READ,
    twin_workspace_query_channel_records: READ,
    twin_workspace_read_attached_view: READ,
    twin_workspace_record_source_action: WRITE,
    twin_workspace_run_automation_now: WRITE,
    twin_workspace_search_inbox: READ,
    twin_workspace_set_channel_feed_reaction: WRITE,
    twin_workspace_unwatch_resource: WRITE,
    twin_workspace_update_automation: WRITE,
    twin_workspace_update_channel: WRITE,
    twin_workspace_update_channel_feed_comment: WRITE,
    twin_workspace_update_channel_member: WRITE,
    twin_workspace_update_channel_post: WRITE,
    twin_workspace_update_channel_view: WRITE,
    twin_workspace_update_notification_preference: WRITE,
    twin_workspace_update_object_field: WRITE,
    twin_workspace_update_object_fields: WRITE,
    twin_workspace_update_object_type: WRITE,
    twin_workspace_update_record: WRITE,
    twin_workspace_update_records: WRITE,
    twin_workspace_upsert_channel_member: WRITE,
    twin_workspace_watch_resource: WRITE,
    warehouse_describe_table: READ,
    warehouse_list_tables: READ,
    warehouse_query: READ,
});
export function nativeToolContract(name) {
    return Object.hasOwn(NATIVE_TOOL_CONTRACTS, name)
        ? NATIVE_TOOL_CONTRACTS[name]
        : undefined;
}
export function nativeToolNamesWhere(predicate) {
    return Object.keys(NATIVE_TOOL_CONTRACTS)
        .filter((name) => predicate(NATIVE_TOOL_CONTRACTS[name]));
}
